module.exports = __webpack_public_path__ + "img/volcengine.e2c95f76.jpg";